export function PeriodButton({ option, active, onSelect, onApply }) {
  const handleClick = () => {
    onSelect(option.value);
    if (option.value !== "custom") onApply?.();
  };

  return (
    <button
      type="button"
      aria-pressed={active}
      className={`rounded-md border px-3 py-2 text-sm font-medium transition-colors ${active
        ? "border-scale-500 bg-scale-500 text-background"
        : "border-gray-300 bg-background text-gray-700 hover:border-scale-400"
      }`}
      onClick={handleClick}
    >
      {option.label}
    </button>
  );
}
